import type { AnalysisSeries } from './analysis';
import type { AnalysisMode } from './types';

export function waveformIdentity(series: AnalysisSeries): { quantity: 'Voltage' | 'Current'; phase: string } | null {
  const match = series.name.match(/^(Voltage|Current):\s*(L1|L2|L3|Neutral)$/i);
  if (!match) return null;
  return {
    quantity: match[1].toLowerCase() === 'voltage' ? 'Voltage' : 'Current',
    phase: match[2] === 'Neutral' ? 'Neutral' : match[2].toUpperCase()
  };
}

export function waveformChoicesForMode(mode: AnalysisMode, series: AnalysisSeries[]): AnalysisSeries[] {
  if (mode === 'calculated-power') {
    return series.filter((candidate) => {
      const identity = waveformIdentity(candidate);
      return identity?.quantity === 'Voltage'
        && identity.phase !== 'Neutral'
        && series.some((other) => {
          const otherIdentity = waveformIdentity(other);
          return otherIdentity?.quantity === 'Current' && otherIdentity.phase === identity.phase;
        });
    });
  }
  if (mode === 'three-phase-balance') {
    return series.filter((candidate) => {
      const identity = waveformIdentity(candidate);
      if (!identity || identity.phase !== 'L1') return false;
      return ['L1', 'L2', 'L3'].every((phase) => series.some((other) => {
        const otherIdentity = waveformIdentity(other);
        return otherIdentity?.quantity === identity.quantity && otherIdentity.phase === phase;
      }));
    });
  }
  return series;
}

export function waveformChoiceLabel(mode: AnalysisMode, series: AnalysisSeries): string {
  const identity = waveformIdentity(series);
  if (mode === 'calculated-power') return identity?.phase ?? series.name;
  if (mode === 'three-phase-balance') return identity?.quantity ?? series.name;
  return series.name;
}
